import FullScreenDialog from '@components/layout/full-screen-dialog';
import WebcamCapture from '@components/webcam';
import { GeoAndIP } from '@components/webcam/helpers';
import { isDesktop } from '@global/helpers/general';
import { Button, CircularProgress, Grid } from '@mui/material';
import { RootState } from '@redux/store';
import { Dispatch, SetStateAction, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './styles';

interface CapturePicProps {
  title: string;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleProceed: (
    image: string,
    setLoading?: Dispatch<SetStateAction<boolean>>,
    extraAttributes?: any
  ) => void;
  acceptGeolocation?: boolean;
}

function CapturePic(props: CapturePicProps) {
  const { open, setOpen, handleProceed, title, acceptGeolocation } = props;
  const profile = useSelector((s: RootState) => s.profile);
  const flipButtonRef = useRef<HTMLButtonElement>(null);
  const webCamCaptureRef = useRef<HTMLButtonElement>(null);
  const proceedButtonRef = useRef<HTMLButtonElement>(null);
  const [image, setImage] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [geolocation, setGeolocation] = useState<GeoAndIP | null>(null);
  const getAspectRatio = () => {
    if (isDesktop()) {
      return 1.2;
    }
    return window.innerWidth / window.innerHeight + 0.45 * (window.innerWidth / window.innerHeight);
  };

  const uploadFromGallery = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.onchange = (e) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          const base64 = reader.result as string;
          setImage(base64);
        };
        reader.readAsDataURL(file);
      }
    };
    fileInput.click();
  };
  return (
    <FullScreenDialog
      open={open}
      setOpen={() => {
        setOpen(false);
      }}
      title={title}
      fullScreen={!isDesktop()}
      sx={{ background: '#000', height: '100%' }}>
      <Grid
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          background: '#000000',
          height: '100vh'
        }}>
        {image ? (
          <img
            src={image}
            alt="captured"
            style={{
              // width: isDesktop() ? "50%" : "100%",
              // maxWidth: `${MAX_WIDTH}px`,
              padding: '1em',
              objectFit: 'contain',
              width: isDesktop() ? '33vw' : '100%',
              opacity: loading ? 0.5 : 1,
              filter: loading ? 'blur(3px)' : 'blur(0)'
            }}
          />
        ) : (
          <WebcamCapture
            setImage={setImage}
            buttonRef={webCamCaptureRef}
            flipButtonRef={flipButtonRef}
            aspectRatio={getAspectRatio()}
            setOpenDialog={setOpen}
            acceptGeolocation={acceptGeolocation}
            setGeolocation={setGeolocation}
          />
        )}

        {image ? (
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              position: 'absolute',
              bottom: '10px',
              width: '95%',
              margin: '0 8px'
            }}>
            <Button
              sx={styles.bottomBtn}
              disabled={loading}
              onClick={async () => {
                setImage('');
              }}>
              Retake
            </Button>
            <Button
              disableFocusRipple
              disableRipple
              disabled={loading}
              sx={styles.bottomBtn}
              onClick={async (event) => {
                event.preventDefault();
                handleProceed(image, setLoading, { data: geolocation });
              }}>
              Proceed
            </Button>
          </Grid>
        ) : (
          <Grid
            container
            direction="column"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              position: 'absolute',
              bottom: '10px',
              width: '95%',
              margin: '0 8px'
            }}>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              sx={{
                width: '95%'
              }}>
              {/* {
            formInfo[currentCredentialUnderFetch?.key]?.skipAllowed && (
            formInfo[currentCredentialUnderFetch?.key]?.state === statesEnum.NOT_INITIALIZED ||
            formInfo[currentCredentialUnderFetch?.key]?.state === statesEnum.DATA_SAVED
          ) ? <Button
            variant="outlined"
            loading={loadingSkip}
            sx={{ width: '45%', margin: '1em auto' }}
            onClick={async () => {
              skip();
            }}>
            Skip
          </Button> : null
          } */}

              {(import.meta.env.VITE_UPLOAD_PASSPORT_FROM_LOCAL || profile.agentId) && (
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    width: '100%',
                    mb: '1em'
                  }}>
                  <Button
                    variant="contained"
                    sx={styles.bottomBtn}
                    onClick={() => {
                      uploadFromGallery();
                    }}>
                    Upload from {isDesktop() ? ' Computer' : ' Gallery'}
                  </Button>
                </Grid>
              )}
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  width: '100%'
                }}>
                <Button
                  variant="contained"
                  sx={styles.bottomBtn}
                  onClick={() => {
                    flipButtonRef.current?.click();
                  }}>
                  Flip Camera
                </Button>

                <Button
                  ref={proceedButtonRef}
                  autoFocus={false}
                  disableFocusRipple
                  disableRipple
                  id="capture"
                  variant="contained"
                  sx={styles.bottomBtn}
                  onClick={async (event) => {
                    event.preventDefault();
                    proceedButtonRef.current?.blur();
                    webCamCaptureRef.current?.click();
                  }}>
                  Capture
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>

      {loading ? (
        <CircularProgress
          sx={{ position: 'absolute', top: '48%', left: '48%', color: 'primary.light' }}
        />
      ) : null}
    </FullScreenDialog>
  );
}

export default CapturePic;
